/**
 * Task counts per status for the dashboard tiles.
 *
 * Shared by DashboardPage and PracticeContext, which warm the SAME cache entry —
 * any divergence between them shows the user different numbers before and after
 * the page's own refetch, so the loop lives here exactly once.
 *
 * 'processing_by_deskbot' folds into 'in-progress': it is a super_admin-only
 * status and both views are member-visible, so it gets no tile of its own — but
 * an unrecognised status is dropped by the hasOwnProperty guard, which would
 * make the tiles silently under-count.
 */
export const countTasksByStatus = (tasks) => {
  const counts = { pending: 0, 'in-progress': 0, completed: 0, completed_by_deskbot: 0, weitergeleitet: 0, unreachable: 0, verpasster_anruf: 0 };
  (tasks || []).forEach((task) => {
    const bucket = task.status === 'processing_by_deskbot' ? 'in-progress' : task.status;
    if (counts.hasOwnProperty(bucket)) counts[bucket]++;
  });
  return counts;
};

// Statuses the 'in-progress' tile now represents — the Dashboard drill-down
// hands these to the Tasks page so the filtered list cannot show fewer rows
// than the number just clicked.
export const IN_PROGRESS_TILE_STATUSES = ['in-progress', 'processing_by_deskbot'];
